/* TODO: after removing the UMD hack/stub */
import { JSX } from "react"; // typing only
import { useRef, useState } from "react";

// import { LocalizationProvider } from "@fluent/react";
declare var React: any
declare type ReactElement = {}

import ToggleButton from 'react-bootstrap/ToggleButton';
// https://www.npmjs.com/package/react-bootstrap-icons
// import * as Icon from 'react-bootstrap-icons';
import * as icons from 'react-bootstrap-icons'; // typing only
import { Icon } from "../../react-entry";

//  XXX: plugins.ts (a re-export module), if anything
// import { BookTypeEnum } from "../Plugins/Bibliography/BibliographyModule";
import {
    BookTypeEnum,
} from "../types";

import { IconButton } from "./IconButton";

type EntryButtonsProps = {
    baseUrl: string,
    data,
    getTextLegacy, // TODO: types
    getUrlPrefix,
    pascalCaseData,
    showHideDetails,
}

enum ButtonType {
    Details = 'details',
    //  XXX: edition notes are similar to information on a dictionary (ESSČ)
    // NOTE: historic dictionaries have edition notes (in TEI in eXist-db)
    //       instead of a Markdown preface (static text in a relational DB);
    //       for backwards compatibility, the MD preface has a priority over
    //       the TEI editions notes, if linkingAbbreviation is provided
    Info = 'info',
    Notes = 'notes',
    Open = 'open',
}

enum WidgetType {
    IconButton = 'IconButton',
    IconToggleButton = 'IconToggleButton',
}

type ButtonVariables = {
    type?: WidgetType,

    // localization: message IDs
    label: string;
    tooltip?: string;

    uppercaseLabel?: boolean;
    value?: string;

    checked?: () => boolean;
    iconName: () => keyof typeof icons;
    id?: () => string;
    onClick?: () => any,
    url?: () => string;
}

type Blueprint = {
    buttons: ButtonType[],
    //  OLD: typeof ButtonPropsBase
    //  NEW: constructor type (thanks, Copilot / Claude Sonnet 4!)
    variables: new (
        props: EntryButtonsProps, params: GetButtonsParams
    ) => ButtonPropsBase,
}

type GetButtonsParams = {
    //  XXX: this is different from the one in props
    showHideDetails,
    detailsShown: boolean,
    setDetailsShown,
}

export function EntryButtons(
    props: EntryButtonsProps)
{
    const data: IBookContract = props.data;

    // @ts-ignore
    const [detailsShown, setDetailsShown] = useState<boolean>(false);

    const divRef = useRef(null);
    const showHideDetails = () => props.showHideDetails(
        divRef.current, props.pascalCaseData);

    const blueprint = buttonsPerBookType[data.bookType];

    if (!blueprint)
        return null;

    // TODO: drop GetButtonsParams by merging getEntryButtons in here?
    // TODO: figure out how to split these long functions differently?
    //       (by extracting components to the top level – first?)
    const params = {
        showHideDetails,
        detailsShown,
        setDetailsShown,
    };

    const buttons = getEntryButtons(props, params, blueprint);

    // TODO: Container > Row > Col?
    return <div
        className="entry-buttons mt-3"
        ref={divRef}
    >{
        buttons.map((button, index) =>
            <span key={index + 1}>{
                button
            }</span>)
    }</div>;
}

const getEntryButtons = (
    props: EntryButtonsProps,
    params: GetButtonsParams,
    blueprint: Blueprint
) =>
{
    const buttons = [];

    const vars = new blueprint.variables(props, params);

    for (let buttonType of blueprint.buttons) {
        const buttonVars: ButtonVariables = vars.buttonVars[buttonType];

        if (!buttonVars) {
            continue;
        }

        const widgetType = buttonVars.type ?? WidgetType.IconButton;
        const widgetFactory = widgetFactories[widgetType];

        if (!widgetFactory) {
            continue;
        }

        const widget = widgetFactory(props, buttonVars);

        // NOTE: the info button requires a linkingAbbreviation
        if (!widget) {
            continue;
        }

        buttons.push(widget);
    }

    return buttons;
}

class ButtonPropsBase
{
    props: EntryButtonsProps;
    params: GetButtonsParams;

    baseUrl: string;
    data: IBookContract;

    buttonVars: {[buttonType in ButtonType]?: ButtonVariables};

    constructor(props: EntryButtonsProps, params: GetButtonsParams)
    {
        this.props = props;
        this.params = params;

        this.baseUrl = props.baseUrl;
        this.data = props.data;

        this.buttonVars = {};

        this.buttonVars[ButtonType.Notes] = {
            // type: WidgetType.IconButton,
            iconName: () => 'Pen',

            label: 'BibliographyModule.EditionNote',
            uppercaseLabel: true,

            url: () =>
            {
                // NOTE: editions of dictionaries may link to a simple Markdown
                //       preface through a linkingAbbreviation; if it is null,
                //       a link to TEI edition notes is shown instead
                const abbr = this.data.linkingAbbreviation;

                if (abbr) {
                    return null;
                }

                const bookId = this.bookId();
                return `${this.baseUrl}EditionNote/EditionNote?bookId=${bookId}`;
            }
        };

        this.buttonVars[ButtonType.Details] = {
            type: WidgetType.IconToggleButton,

            iconName: () =>
            {
                const detailsShown = this.params.detailsShown;

                return `Chevron${detailsShown ? 'Up' : 'Down'}`;
            },

            id: () =>
            {
                return `show-details-${this.bookId()}`;
            },

            label: 'layout.Information',

            checked: () => this.params.detailsShown,
            value: 'detailsShown',

            onClick: () =>
            {
                const params = this.params;
                const shown: boolean = params.showHideDetails();
                params.setDetailsShown(shown);
            },
        };
    }

    // TODO: deduplicate, BibliographyLine performs similar stuff
    // TODO: i.e. provide this information via props already
    urlPrefix(): string
    {
        return this.props.getUrlPrefix(this.baseUrl, this.data.bookType);
    }

    abbr()
    {
        const data = this.data;

        return data.linkingAbbreviation ??
            data.sourcePartAbbreviation ??
            data.sourceAbbreviation;
    }

    bookId(): string | number
    {
        //  XXX: the interface is something else/other than IBookContract
        // @ts-ignore
        return this.data.bookId;
    }
}

class DictionaryButtonProps extends ButtonPropsBase
{
    constructor(props: EntryButtonsProps, params: GetButtonsParams)
    {
        super(props, params);

        this.buttonVars[ButtonType.Info] = {
            // type: WidgetType.IconButton,
            iconName: () => 'InfoCircle',

            // NOTE: “traditionally” (in VW1), this is called a “foreword”
            label: 'PluginsJs.DictionaryInfo',
            tooltip: 'PluginsJs.DictionaryInfoTooltip',

            // TODO: maybe even verify (at the backend) that the static text
            //       actually exists
            // NOTE: the endpoint now finally returns a 404 so the backend
            //       definitely knows
            url: () =>
            {
                const abbr = this.data.linkingAbbreviation;

                if (!abbr) {
                    return null;
                }

                //  OLD: both the area and controller names (identical) were
                //       long required here
                return `${this.urlPrefix()}text/${abbr}`;
            }
        };
    }
}

class EditionButtonProps extends ButtonPropsBase
{
    constructor(props: EntryButtonsProps, params: GetButtonsParams)
    {
        super(props, params);

        this.buttonVars[ButtonType.Open] = {
            // type: WidgetType.IconButton,
            iconName: () => 'Book',

            label: 'PluginsJs.OpenEdition',

            url: () =>
            {
                return `${this.urlPrefix()}${this.abbr()}`;
            }
        };
    }
}

class GrammarButtonProps extends ButtonPropsBase
{
    constructor(props: EntryButtonsProps, params: GetButtonsParams)
    {
        super(props, params);

        this.buttonVars[ButtonType.Open] = {
            // type: WidgetType.IconButton,
            iconName: () => 'Book',

            label: 'PluginsJs.OpenGrammar',

            url: () =>
            {
                // TODO: see listGrammarBookReadClicked
                return `${this.baseUrl}BookReader/BookReader/Listing?bookId=${this.bookId()}&searchType=Terms`;
            }
        };
    }
}

// NOTE: BookTypeEnum is now used “statically” here, earlier than before and thus
//       also needs to be available earlier, without cyclic dependencies
const buttonsPerBookType: {[bookType in BookTypeEnum]?: Blueprint} = {
    [BookTypeEnum.Edition]: {
        buttons: [
            ButtonType.Open,
            ButtonType.Notes,
            ButtonType.Details,
        ],

        variables: EditionButtonProps,
    },

    // TODO: odkazy na autory, zkratky, sešity v PDF, listování, … (libovolně)
    [BookTypeEnum.Dictionary]: {
        buttons: [
            // This links to a Markdown document with a linkingAbbreviation,
            // if provided.
            ButtonType.Info,
            // If linkingAbbreviation is null, we “fall back” to TEI edition
            // notes.
            ButtonType.Notes,
        ],

        variables: DictionaryButtonProps,
    },

    [BookTypeEnum.Grammar]: {
        buttons: [
            ButtonType.Open,
            ButtonType.Details,
        ],

        variables: GrammarButtonProps,
    },
};

const getIconButton = (
    props: EntryButtonsProps, vars: ButtonVariables) =>
{
    const url = vars.url();

    // NOTE: if linkingAbbreviation is null, we get no button
    if (!url) {
        return null;
    }

    const iconName = vars.iconName();
    let label = props.getTextLegacy(vars.label);

    if (vars.uppercaseLabel) {
        label = uppercaseFirst(label);
    }

    const tooltipText = props.getTextLegacy(vars.tooltip);

    return (
        <IconButton
            href={url}
            title={tooltipText}
            iconName={iconName}
            label={label}
        />
    );
};

const getIconToggleButton = (
    props: EntryButtonsProps, vars: ButtonVariables) =>
{
    const checked = vars.checked();
    const iconName = vars.iconName();
    const id = vars.id(); // `show-details-${bookId}`
    const label = props.getTextLegacy(vars.label);

    return (
    <ToggleButton
        type="checkbox"
        checked={checked}
        value={vars.value}
        onClick={vars.onClick}
        variant="default" // TODO: secondary
        className="me-1"
        id={id}
    >
        <span className="me-2">{label}</span>

        <Icon
            iconName={iconName}
        />
    </ToggleButton>
    );
}

const widgetFactories: {[widgetType in WidgetType]?: (
    props: EntryButtonsProps, vars: ButtonVariables
) => JSX.Element} = {
    [WidgetType.IconButton]: getIconButton,
    [WidgetType.IconToggleButton]: getIconToggleButton,
}

// https://stackoverflow.com/questions/38345372/why-does-a-string-containing-a-single-emoji-like-have-a-length-of-2/64261876#64261876
const charRegex = /./gu;

function uppercaseFirst(input: string): string
{
    if (!input || !input.length)
        return input;

    const first = input.match(charRegex)[0];

    return first.toUpperCase() + input.substring(first.length);
}
